import {h, Fragment} from "preact"
import { useAppState } from "@nosto/preact"
import { useEffect } from "preact/hooks"

export default function NoResults() {
    const {
        response: { query }
    } = useAppState()

    useEffect(()=>{
        nostojs(function (api) {
            api.loadRecommendations();
        })
    })

    return (
        <div class="ns-text-align-center ns-my-5 ns-mx-0 ns-noresults-page ns-m-auto">
            <div class="ns-font-4">No results found for '{query}'</div>
            {window.location.href.includes("/collections/customizer") ?
            <div class="nosto-no-customizer-results">
                <a href='/collections/customizer' class="nosto-go-back-customizer">Go back</a>
            </div>
            :
            <div class="nosto-rec-container">
                <div class="nosto_element" id="notfound-nosto-1"></div>
            </div>
            }
        </div>
    )
}
